module.exports = __webpack_public_path__ + "docusign.svg?039f14bdd25011d4d813556744ed57c6";